module.exports = __webpack_public_path__ + "img/treatment-wetlands.c1afc628.svg";